import { addMinutes, isAfter, isBetween } from '@lingoda/dates';

export const getClassHasStarted = (startDate?: Date, currentTime?: Date) => {
    return !!startDate && !!currentTime && isAfter(currentTime, startDate);
};

export const getClassHasEnded = (endDate?: Date, currentTime?: Date) => {
    return !!endDate && !!currentTime && isAfter(currentTime, endDate);
};

export const getClassIsLive = (
    startDate?: Date,
    endDate?: Date,
    currentTime?: Date,
    minutesInAdvanceAllowed: number = 5,
) => {
    if (!startDate) {
        return false;
    }
    const earlyStartDate = addMinutes(-minutesInAdvanceAllowed)(startDate);

    return !!endDate && !!currentTime && isBetween(earlyStartDate, endDate, currentTime);
};
